import { useState } from "react";
import AnimatedModal from "@/components/base/AnimatedModal";

interface RejectionModalProps {
  isOpen: boolean;
  jobTitle: string;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

export default function RejectionModal({ isOpen, jobTitle, onClose, onConfirm }: RejectionModalProps) {
  const [reason, setReason] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!reason.trim()) return;
    onConfirm(reason.trim());
    setReason("");
  };

  return (
    <AnimatedModal isOpen={isOpen} onClose={onClose} variant="scale">
      <div className="bg-background-50 rounded-2xl p-6 w-[90vw] max-w-md shadow-2xl">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-full flex-shrink-0">
            <i className="ri-close-circle-line text-red-500 text-xl"></i>
          </div>
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">Từ chối tin tuyển dụng</h3>
            <p className="text-xs text-foreground-500 mt-0.5 truncate max-w-[280px]">{jobTitle}</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground-800 mb-1.5">
              Lý do từ chối <span className="text-red-500">*</span>
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Nhập lý do từ chối tin tuyển dụng này (VD: Thông tin không rõ ràng, mức lương không hợp lý, nội dung trùng lặp...)"
              rows={4}
              maxLength={500}
              className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200 rounded-xl text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-red-400 focus:ring-2 focus:ring-red-100 transition-all resize-none"
            />
            <p className="text-xs text-foreground-400 mt-1 text-right">{reason.length}/500</p>
          </div>

          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-2.5 bg-background-100 text-foreground-700 rounded-full text-sm font-semibold hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              Hủy
            </button>
            <button
              type="submit"
              disabled={!reason.trim()}
              className="flex-1 py-2.5 bg-red-500 text-white rounded-full text-sm font-semibold hover:bg-red-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Xác nhận từ chối
            </button>
          </div>
        </form>
      </div>
    </AnimatedModal>
  );
}